// @ts-nocheck
import { Plugin } from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/node_modules/.pnpm/@umijs+runtime@3.5.43_react@16.14.0/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request','qiankun',],
});

export { plugin };
